import { NotificationSeverity } from '../services/notifier';

export abstract class Notification {
  protected message: string | undefined;
  protected title: string | undefined;
  protected abstract severity: NotificationSeverity;

  public get config(): { title: string; message: string; severity: NotificationSeverity } {
    return { title: this.title, message: this.message, severity: this.severity };
  }

  constructor(config: { message?: string; title?: string }) {
    this.message = config?.message;
    this.title = config?.title;
  }
}
